import React from 'react';
import {StreamBankLink} from "../../StreamBankLink";
import {service as SpeciesService} from "../../../../Services/SpeciesService";

export const SpeciesActivityTitle = props => {
    const {contextNodeActivity} = props;
    const {Activity: activity = null} = contextNodeActivity;
    const {data: activityData = null} = activity;
    const species = activityData?.newValue;
    const speciesTitle = SpeciesService.GetFullTitle(species);
    
    return <StreamBankLink Href={"/allSpecies"}>{speciesTitle ?? "Species List Activity"}</StreamBankLink>;
};


